import styled from "styled-components/native";

import { spacers, colors } from "~/styles/theme";

export const Container = styled.ScrollView`
  background-color: ${({ theme }) => theme.colors.gray100};
  border-radius: ${spacers.ss4};
`;
